let _ = t => t,
  _t;
import styled from 'foundations-theming/utils';
import { breakpoint } from 'pricing-pages-ui-components/constants/Breakpoints';
import { currentOrderedPaidProductLevels } from 'self-service-api/constants/ProductLevels';
import ProductLevelSelectionButtonContainer from './ProductLevelSelectionButtonContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const ResponsiveFlex = styled.div.withConfig({
  displayName: "HubProductLevelPicker__ResponsiveFlex",
  componentId: "ziux3e-0"
})(["display:flex;flex-direction:row;", ""], breakpoint.phone(_t || (_t = _`
    flex-direction: column;
  `)));
const HubProductLevelPicker = ({
  productLine,
  selectedProductLevel,
  setSelectedProductLevel,
  ariaLabelledById,
  isLoading
}) => {
  return /*#__PURE__*/_jsx(ResponsiveFlex, {
    role: "group",
    "aria-labelledby": ariaLabelledById,
    children: currentOrderedPaidProductLevels.map(productLevel => {
      const isProductLevelSelected = selectedProductLevel === productLevel;
      return /*#__PURE__*/_jsx(ProductLevelSelectionButtonContainer, {
        productLine: productLine,
        productLevel: productLevel,
        selected: isProductLevelSelected,
        disabled: isLoading,
        onClick: () => {
          if (!isProductLevelSelected) {
            setSelectedProductLevel(productLevel);
          } else {
            setSelectedProductLevel(null);
          }
        }
      }, productLevel);
    })
  });
};
export default HubProductLevelPicker;